import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AlertFacade } from '@core';
import { AppAlert } from '@models';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertsComponent {
  constructor(_alertService: AlertFacade) {
    this.alerts$ = _alertService.alerts$;
  }

  public alerts$: Observable<AppAlert[]>;
}
